export { default } from "./ResourcePageSearchComboBox";
